import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { STRINGS } from "../utils/strings";
import { useCaseListStore } from "../hooks/useCaseListStore";
import Svg, {SvgEnum} from "../../../../../../ui library/components/svgs/standard/svg";

const Search = ({ id, filters, updateFilter, inputLabelProps }) => {
  const filterState = useCaseListStore((state) => state.filterUI);
  const setActiveChipLabel = useCaseListStore((state) => state.setActiveChipLabel);
  const setChipActive = useCaseListStore((state) => state.setChipActive);
  const setSearchValue = useCaseListStore((state) => state.setSearchValue);

  const [userTyping, setUserTyping] = useState();


  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      border: '1px solid #94A3B8',
      borderRadius: '35px',
      paddingLeft: '12px',
    }}>
      <Svg name={SvgEnum.HisMagnifyingGlass} />
      <TextField
        className="placeholder:text-center rounded-lg w-full text-sm"
        placeholder={STRINGS.SEARCH_PLACEHOLDER}
        size="small"
        name="case-search"
        value={filterState?.search.selectedValue}
        InputLabelProps={{
          shrink: true,
          style: {
            border: 'none',
          },
          ...inputLabelProps
        }}
        onChange={(event) => {
          setSearchValue("search", event.target.value);
          clearTimeout(userTyping);
          setUserTyping(
            setTimeout(() => {
              updateFilter("search", event.target.value);
              setChipActive("search", true);
              setActiveChipLabel("search", event.target.value);

            }, 1000)
          );
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              border: 'none',
            },
            '&:hover fieldset': {
              border: 'none',
            },
            '&.Mui-focused fieldset': {
              border: 'none',
            },
          },
        }}
      />
    </div>
  );
};
export default Search;
